import { useTranslate } from '@bynder/localization';
import { Tabs } from '@bynder/design-system';
import { useWidgetMutations } from '../../../../mutations/widgets/widgets';
import { track } from '../../../../helpers/analytics';
import { useActiveWidget } from '../../../../queries/guides';
import { ModalType, WIDGET_TYPE } from '../../../../types';
import { InspectorSetting } from '../../../../constants/guides';
import { useInspectorStore } from '../../../../stores/inspectorStore';
import { useModalStore } from '../../../../stores/modalStore';
import { IconDelete } from '@bynder/icons';
import React, { ReactNode } from 'react';

const WidgetSettingsFooter: React.FC<{ children?: ReactNode[] }> = ({
  children,
}) => {
  const widget = useActiveWidget();
  const { translate } = useTranslate();
  const openModal = useModalStore.use.openModal();
  const setActiveInspectorSetting = useInspectorStore(
    s => s.setActiveInspectorSetting,
  );
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const setWidgetSettings = useInspectorStore(s => s.setWidgetSettings);
  const { deleteWidget } = useWidgetMutations(
    widgetSettings?.sectionId,
    widgetSettings?.columnIndex,
    widgetSettings?.widgetId,
  );

  const onDeleteWidget = () => {
    if (widget?.type === WIDGET_TYPE.TEXT) {
      track('Text Widget Deleted');
    }

    setWidgetSettings(null);
    setActiveInspectorSetting(InspectorSetting.SECTION_VIEW);
    deleteWidget.mutate();
  };

  const handleDelete = () => {
    const modalProps = {
      headerText: translate('DELETE_WIDGET_MODAL.HEADER_TEXT'),
      contentText: translate('DELETE_WIDGET_MODAL.CONTENT_TEXT'),
    };
    openModal({
      modalType: ModalType.DELETE_MODAL,
      modalOnSubmit: onDeleteWidget,
      modalProps,
    });
  };

  return (
    <Tabs variant="clean">
      {children && [...children]}
      <Tabs.Tab
        label={translate('WIDGETS_CONSTANTS.DELETE_WIDGET_BUTTON')}
        isLabelHidden
        icon={<IconDelete />}
        isActive={false}
        onClick={handleDelete}
      />
    </Tabs>
  );
};

export default WidgetSettingsFooter;
